export const pickerColors = ['#844CE7', '#77BE79', '#527DFF', '#1489A4', '#EC4D57', '#F1A404', '#1B69A6', '#42526E', '#F84794', '#00C9D8'];
export const defaultTaskColor = '#527dff';
